<template>
  <v-data-table
    v-if="!isSala"
    :headers="visualizarPontosMedalha ? headers : headersSemPontos"
    :items="perguntasEvidenciadas"
    class="elevation-1"
    hide-default-footer
    disable-pagination
    :expanded.sync="expanded"
    single-expand
    item-key="perguntaMunicipioId"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
  >
    <template v-slot:item="props">
      <tr class="evidenciada">
        <td
          v-if="canDiscardQuestion(props.item)"
          @click="removeQuestion(props.item)"
          style="cursor: pointer"
          title="DESCARTAR QUESTÃO E EVIDÊNCIAS"
        >
          <img style="width: 30px" src="/assets/img/removeQuestion.png" />
        </td>
        <td v-else></td>
        <td>{{ props.item.nome }}</td>
        <td>{{ props.item.numero }}</td>
        <td>
          <div>
            <div>{{ props.item.texto }}</div>
            <div
              v-if="getRespostaNumericaInfo(props.item)"
              class="resposta-numerica-info"
            >
              {{ getRespostaNumericaInfo(props.item) }}
            </div>
          </div>
        </td>
        <td @click="openEvidence(props.item)" v-if="props.item.temArquivo">
          <div class="optionsExpanded">
            <div
              :class="`openExpanded ${
                expanded.length > 0 &&
                props.item.perguntaMunicipioId ===
                  expanded[0].perguntaMunicipioId
                  ? 'expandedClass'
                  : ''
              }`"
              v-if="
                isFullAdmin ||
                (groupsConfig.visualizarEvidenciadas &&
                  config.visualizarEvidenciadas)
              "
            ></div>
          </div>
        </td>
        <td v-else></td>
        <td v-if="!isSala">{{ props.item.pontos }}</td>
        <td width="300px">
          <template
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-file-input
              v-if="!consultaSomenteLeitura(props.item) && (
                isFullAdmin ||
                (groupsConfig.enviarEvidenciadas && config.enviarEvidenciadas)
              )"
              multiple
              label="Selecione Arquivos de Evidência"
              v-model="props.item.arquivos"
            >
            </v-file-input>
          </template>
        </td>
        <td>
          <template
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-btn
              v-if="!consultaSomenteLeitura(props.item) && (
                isFullAdmin ||
                (groupsConfig.enviarEvidenciadas && config.enviarEvidenciadas)
              )"
              color="primary"
              class="ml-3"
              @click="sendEvidences(props.item)"
            >
              <span v-if="isSala">Carregar</span>
              <span v-else>Enviar</span>
            </v-btn>
          </template>
        </td>
        <td v-if="props.item.evidencia">
          <app-modal-show-evidence
            :evidence="props.item.evidencia"
            :color="'primary'"
            :isHtml="isSala ? true : false"
          >
          </app-modal-show-evidence>
        </td>
        <td v-else></td>
      </tr>
    </template>
    <template v-slot:expanded-item="props">
      <tr
        v-if="
          isFullAdmin ||
          (groupsConfig.visualizarEvidenciadas && config.visualizarEvidenciadas)
        "
      >
        <td colspan="9" class="p-0">
          <app-get-evidence-question
            :perguntaId="props.item.perguntaMunicipioId"
            @updateValue="updateValue"
            :evidences="evidences"
            :type="'Evidenciadas'"
            :canAnalyze="canAnalyzeQuestion(props.item)"
           :readonly="consultaSomenteLeitura(props.item)"></app-get-evidence-question>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <span> Nenhuma pergunta retornada </span>
    </template>
  </v-data-table>
  <evidenciada-selo
    :visualizarPontosMedalha="visualizarPontosMedalha"
    :headers="headers"
    :headersSemPontos="headersSemPontos"
    :perguntasEvidenciadas="perguntasEvidenciadas"
    :payload="payload"
    :rulesArquivo="rules"
    :expanded="expanded"
    @openEvidence="openEvidence"
    :evidences="evidences"
    @updateValue="updateValue"
    @sendEvidences="sendEvidences"
    @removeQuestion="removeQuestion"
    @load="loadHighlightedQuestions"
    @finalizarAnalise="loadHighlightedQuestions(true)"
    v-else
  ></evidenciada-selo>
</template>

<script>
import { cityQuestionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppGetEvidenceQuestion from "@/modules/evidence/components/GetQuestion";
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import { sortArrayAsc } from "../../../../helpers/utils";

import Swal from "sweetalert2";
import EvidenciadaSelo from "./selo/EvidenciadaSelo.vue";
import { criterio5API } from "./selo/criterio5API";
import { getRespostaNumericaInfo as buildRespostaNumericaInfo } from "./utils";
import { confirmarAnaliseIaUpload } from "./preAnaliseUpload";

import seloEvidenceReadScopeMixin from "@/utils/seloEvidenceReadScopeMixin";

export default {
  mixins: [seloEvidenceReadScopeMixin],
  components: {
    AppGetEvidenceQuestion,
    AppModalShowEvidence,
    EvidenciadaSelo,
  },
  data() {
    return {
      criterio5Ativo: false,
      sortBy: ["nome"],
      sortDesc: [false],
      headers: [
        { text: "", value: "removeEvidence" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "evidencia" },
      ],
      headersSemPontos: [
        { text: "", value: "removeEvidence" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "evidencia" },
      ],
      payload: {},
      rules: [
        (files) => {
          if (files) {
            const arquivos = Array.isArray(files) ? files : [files];
            var somaTotal = arquivos.reduce((a, b) => {
              return a + (b.size || 0);
            }, 0);

            return somaTotal > 209715200
              ? "Total de arquivos não pode ser maior que 200MB!"
              : true;
          }

          return !files;
        },
      ],
      municipioId: this.$route.params.id,
      perguntasEvidenciadas: [],
      expanded: [],
      allPerguntas: [],
      evidences: [],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  props: {
    filter: { type: Object, default: () => ({}) },
    visualizarPontosMedalha: false,
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        console.log("filter changed: ", val);
        if (val.temas.length) {
          this.perguntasEvidenciadas = this.allPerguntas.filter((pa) =>
            val.temas.some((te) => te.nome === pa.nome)
          );
        } else this.perguntasEvidenciadas = this.allPerguntas;

        if (this.isSala && !this.isFullAdmin && !this.criterio5Ativo) {
          this.perguntasEvidenciadas = this.perguntasEvidenciadas.filter(
            (pa) => pa.numero != 5
          );
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    getRespostaNumericaInfo(question) {
      return buildRespostaNumericaInfo(question);
    },
    canAnalyzeQuestion(question) {
      if (this.consultaSomenteLeitura(question)) return false;
      if (this.isFullAdmin) return true;
      if (
        !this.user ||
        !this.user.grupo ||
        this.user.grupo.nome !== "Avaliador Sebrae"
      ) {
        return true;
      }

      const questionMunicipioId = question.municipioId || question.MunicipioId;
      const questionEixoId =
        question.eixoId ||
        question.EixoId ||
        (question.tema && (question.tema.eixoId || question.tema.EixoId));

      return (this.user.permissoes || []).some((permission) => {
        const municipioPermitido =
          !permission.municipioId ||
          Number(permission.municipioId) === Number(questionMunicipioId);
        const eixoPermitido =
          !permission.eixoId ||
          Number(permission.eixoId) === Number(questionEixoId);

        return municipioPermitido && eixoPermitido;
      });
    },
    canDiscardQuestion(question) {
      return (
        this.isFullAdmin ||
        (this.config &&
          this.groupsConfig &&
          this.config.descartarEvidencias &&
          this.groupsConfig.descartarEvidencias &&
          this.canAnalyzeQuestion(question))
      );
    },
    removeQuestion(pergunta) {
      if (!this.canDiscardQuestion(pergunta)) return;

      Swal.fire({
        title: "Atenção!",
        text: `Deseja realmente DESCARTAR esta questão e todas as suas evidências para retorno da mesma à
             situação de RESPONDIDAS? Desta forma, no próximo acompanhamento a questão aparecerá novamente e o
             ${
               this.isGov ? "projeto" : "município"
             }  perderá os pontos correspondentes`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.setLoading(true);
          cityQuestionAPI
            .atualizarPergunta(pergunta.perguntaMunicipioId)
            .then(() => {
              this.loadHighlightedQuestions();
            })
            .catch(() => {
              this.setLoading(false);
              this.$notification.error("Erro ao salvar remover questão");
            });
        }
      });
    },
    openEvidence(evidenceSlot) {
      if (this.expanded.length > 0) {
        this.expanded.forEach((item, index) => {
          if (item === evidenceSlot) {
            this.expanded.splice(index, 1);
          } else {
            this.expanded = [];
            this.expanded.push(evidenceSlot);
          }
        });
      } else {
        this.expanded.push(evidenceSlot);
      }
      if (this.expanded[0]) {
        this.setLoading(true);
        cityQuestionAPI
          .getPergunta(this.expanded[0].perguntaMunicipioId)
          .then((resp) => {
            this.evidences = resp.data.evidencias;
            this.setLoading(false);
          })
          .catch((err) => {
            console.log("err: ", err);
            this.setLoading(false);
            this.$notification.error("Erro ao obter pergunta");
          });
      }
    },
    async sendEvidences(question) {
      const arquivos = Array.isArray(question.arquivos)
        ? question.arquivos
        : question.arquivos
        ? [question.arquivos]
        : [];

      if (arquivos.length === 0) {
        this.$notification.error("Não há evidências a serem enviadas!");
      } else {
        this.setLoading(true);

        let formData = new FormData();

        for (let i = 0; i < arquivos.length; i++) {
          formData.append("arquivos", arquivos[i]);
        }

        formData.append("perguntaMunicipioId", question.perguntaMunicipioId);

        const prosseguir = await confirmarAnaliseIaUpload(
          formData,
          (value) => this.setLoading(value),
          this.config,
          this.groupsConfig
        );
        if (!prosseguir) return;

        cityQuestionAPI
          .salvarEvidencias(formData)
          .then((resp) => {
            this.$notification.success("Evidência salva com sucesso");
            this.loadHighlightedQuestions();
            this.expanded = [];
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao salvar evidência");
          });
      }
    },
    loadHighlightedQuestions(analise) {
      this.setLoading(true);
      cityQuestionAPI
        .getEvidenciadas(this.municipioId)
        .then((resp) => {
          this.perguntasEvidenciadas = resp.data.sort((a, b) => {
            return (
              sortArrayAsc(a.nome, b.nome) || sortArrayAsc(a.texto, b.texto)
            );
          });

          if (!this.consultaCompletaSelo && !this.user.grupo.verTodosEixos) {
            this.perguntasEvidenciadas = this.perguntasEvidenciadas.filter(
              (item) =>
                this.user.permissoes.some(
                  (per) =>
                    per.eixoId === item.eixoId &&
                    per.municipioId === item.municipioId
                )
            );
          }
          this.allPerguntas = this.perguntasEvidenciadas;

          if (this.filter.temas.length > 0) {
            this.perguntasEvidenciadas = this.allPerguntas.filter((pa) =>
              this.filter.temas.some((te) => te.nome === pa.nome)
            );
          }

          if (this.isSala && !this.isFullAdmin && !this.criterio5Ativo) {
            this.perguntasEvidenciadas = this.perguntasEvidenciadas.filter(
              (pa) => pa.numero != 5
            );
          }
          this.setLoading(false);
          if (analise) {
            this.$notification.success("Evidência finalizada com sucesso");
          }
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    updateValue() {
      this.loadHighlightedQuestions();
    },
  },

  async mounted() {
    if (this.isSala) {
      try {
        const { data } = await criterio5API.configuracao();
        this.criterio5Ativo = !!data.habilitado;
      } catch (error) {
        this.criterio5Ativo = false;
      }
    }
    this.loadHighlightedQuestions();

    if (this.isSala) {
      this.headers = [
        { text: "Pilar", value: "nome" },
        { text: "Critério", value: "texto" },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "evidencia" },
        { text: "", value: "", sortable: false },
      ];
      this.headersSemPontos = [
        { text: "Pilar", value: "nome" },
        { text: "Critério", value: "texto" },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "evidencia" },
        { text: "", value: "", sortable: false },
      ];
    } else {
      this.headers = [
        { text: "", value: "removeEvidence", sortable: false },
        { text: "Tema", value: "nome" },
        { text: "Número", value: "numero" },
        { text: "Texto", value: "texto" },
        { text: "", value: "aaa", sortable: false },
        { text: "Pontos", value: "pontos" },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "evidencia" },
      ];
    }
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isSala", "isParceiro"]),
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.p-0 {
  padding: 0 !important;
}
.resposta-numerica-info {
  color: #666;
  font-size: 11px;
  line-height: 1.3;
  margin-top: 4px;
}
.hasEvidence {
  background: url("/assets/img/certo1.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.hasNoEvidence {
  background: url("/assets/img/noEvidence.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.semStatus {
  background: url("/assets/img/search.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}

.optionsExpanded {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.openExpanded {
  background: url("/assets/img/right-arrow.png") no-repeat;
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
  float: right;
}
.expandedClass {
  transform: rotate(270deg);
}
</style>
